export const siteInfo = {
  name: "欧美一级视频",
  nameEn: "OMV",
  tagline: "欧美影视精选与资源导航",
  intro:
    "欧美一级视频专注于欧美电影与电视剧的精选资源导航，收录大量不同类型、不同年代的欧美影视作品资料。我们通过清晰的目录、多维筛选与结构化详情，帮助影视爱好者快速了解作品信息、查找感兴趣的内容。",
  email: "contact@omv-movies.example.com",
  workingHours: "周一至周五 10:00 - 18:00（邮件反馈 24 小时内回复）",
  icp: "本站为影视资料导航演示站点，全部作品信息均为虚构示例内容，不涉及真实版权。",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "热门", to: "/category/movie?sort=hot" },
  { label: "关于", to: "/about" },
];

export const categoryEntries = [
  { label: "欧美电影", desc: "院线大片与经典影片", icon: "ri-film-line", to: "/category/movie" },
  { label: "欧美电视剧", desc: "高分剧集与迷你剧", icon: "ri-tv-2-line", to: "/category/tv" },
  { label: "类型分类", desc: "按题材快速查找", icon: "ri-price-tag-3-line", to: "/category/movie" },
  { label: "地区分类", desc: "美国 / 英国 / 法国等", icon: "ri-earth-line", to: "/category/movie" },
  { label: "年份分类", desc: "最新上线年份作品", icon: "ri-calendar-line", to: "/category/tv" },
  { label: "热门榜单", desc: "当下高热度作品", icon: "ri-fire-line", to: "/category/movie?sort=hot" },
];

export const genreOptions = [
  { label: "剧情", value: "drama" },
  { label: "动作", value: "action" },
  { label: "科幻", value: "scifi" },
  { label: "喜剧", value: "comedy" },
  { label: "悬疑", value: "mystery" },
  { label: "惊悚", value: "thriller" },
  { label: "犯罪", value: "crime" },
  { label: "爱情", value: "romance" },
  { label: "冒险", value: "adventure" },
  { label: "奇幻", value: "fantasy" },
  { label: "战争", value: "war" },
  { label: "历史", value: "history" },
];

export const regionOptions = [
  { label: "美国", value: "usa" },
  { label: "英国", value: "uk" },
  { label: "法国", value: "france" },
  { label: "德国", value: "germany" },
  { label: "加拿大", value: "canada" },
  { label: "澳大利亚", value: "australia" },
  { label: "西班牙", value: "spain" },
  { label: "意大利", value: "italy" },
];

export const yearOptions = [
  { label: "2025", value: "2025" },
  { label: "2024", value: "2024" },
  { label: "2023", value: "2023" },
  { label: "2022", value: "2022" },
  { label: "2021", value: "2021" },
];

export const sortOptions = [
  { label: "最新上线", value: "latest" },
  { label: "最热门", value: "hot" },
  { label: "评分最高", value: "rating" },
];